import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("OfferStore");

const urls = {
  availableOffers: `/bnpl/in_store/available-offers`,
  availableB2bOffers: `/bnpl/in_store/b2b/available-offers`,
};

const initState = () => {
  return {
    offers: [],
    b2bOffers: [],
    offer: null,
    b2bOffer: null,
  };
};

const actions = {
  fetch: async ({ commit }) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.availableOffers);
      commit("saveOffers", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchB2b: async ({ commit }) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.availableB2bOffers);
      commit("saveB2bOffers", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveOffers: (state, data) => {
    Vue.set(state, "offers", data);
    Vue.set(state, "offer", data[0].offerId);
  },
  saveB2bOffers: (state, data) => {
    Vue.set(state, "b2bOffers", data);
    Vue.set(state, "b2bOffer", data[0].offerId);
  },
  setOffer: (state, offerId) => {
    Vue.set(state, "offer", offerId);
  },
  setB2bOffer: (state, offerId) => {
    Vue.set(state, "b2bOffer", offerId);
  },
};

const getters = {
  getOffers: (state) => {
    return state.offers;
  },
  getOffer: (state) => {
    return state.offer;
  },
  getB2bOffers: (state) => {
    return state.b2bOffers;
  },
  getB2bOffer: (state) => {
    return state.b2bOffer;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
